import { z } from 'zod';

/**
 * The Status screens a Partner with a terminal Lead status can land on,
 * addressed by their own URL under `/status/`. partner-facing
 * slugs: deliberately decoupled from the internal screen names and from raw
 * Status reasons, neither of which may ever leak into the URL.
 */
export const STATUS_SCREENS = [
  'waitlist',
  'not-eligible',
  'in-review',
  'already-a-partner',
  'former-partner',
  'tax-id-issue',
  'unsupported-business-type',
] as const;

export type StatusScreen = (typeof STATUS_SCREENS)[number];

export const statusScreenSchema = z.enum(STATUS_SCREENS);
